import { render, staticRenderFns } from "./virtualOrderInfo.vue?vue&type=template&id=32621627&scoped=true"
import script from "./virtualOrderInfo.vue?vue&type=script&lang=js"
export * from "./virtualOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./virtualOrderInfo.vue?vue&type=style&index=0&id=32621627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32621627",
  null
  
)

export default component.exports